import { useSnapshot } from 'valtio';
import { AppStore } from '../store/store';
import { useStoreActions } from '../store/actions';
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import cls from '../styles/Apartments.module.scss';
import 'react-lazy-load-image-component/src/effects/blur.css';

interface Type {
  [x: string]: {
    rooms: string;
    square: string;
  };
}

const apartments: Type = {
  '1': {
    rooms: '2',
    square: '70.6'
  },
  '2': {
    rooms: '3',
    square: '93.6'
  },
  '3': {
    rooms: '2',
    square: '74.7'
  },
  '4': {
    rooms: '1',
    square: '45.1'
  },
  '5': {
    rooms: '2',
    square: '76.2'
  },
  '6': {
    rooms: '3',
    square: '93.6'
  },
  '7': {
    rooms: '2',
    square: '70.6'
  },
  '8': {
    rooms: '2',
    square: '70.6'
  },
  '9': {
    rooms: '1',
    square: '45.4'
  },
  '10': {
    rooms: '1',
    square: '46.9'
  },
  '11': {
    rooms: '1',
    square: '43.6'
  },
  '12': {
    rooms: '1',
    square: '42.7'
  },
  '13': {
    rooms: '1',
    square: '42.0'
  },
  '14': {
    rooms: '1',
    square: '46.9'
  },
  '15': {
    rooms: '1',
    square: '45.4'
  },
  '16': {
    rooms: '2',
    square: '69.1'
  },
};

const ApartmentsP = () => {
  const {
    incrementSelectedFloor,
    decrementSelectedFloor,
    toggleSelectedObject,
    onHoverOverApartment,
    goPrevPage,
  } = useStoreActions();

  const { selectedFloor, selectedObject, selectedApartment } = useSnapshot(AppStore);

  return (
    <div className={cls.mainContainer}>
      <div onClick={() => goPrevPage(22)} className={cls.navigationButton}>
        <img src="./images/arrow.png" alt="" />
        <p>К выбору этажа</p>
      </div>

      <div className={cls.infoContainer}>
        <div className={cls.selectionScreen}>
          <div className={cls.selectionBody}>
            <button onClick={decrementSelectedFloor} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Этаж</p>
              <p>{selectedFloor}</p>
            </div>
            <button onClick={() => incrementSelectedFloor(12)} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>

          <div className={cls.selectionBody}>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronLeft />
            </button>
            <div className={cls.selectedBlock}>
              <p>Блок</p>
              <p>{selectedObject}</p>
            </div>
            <button onClick={toggleSelectedObject} className={cls.arrowButton}>
              <FaChevronRight />
            </button>
          </div>
        </div>

        <div className={cls.detailsContainer}>
          <div className={cls.imageWrapper}>
            <LazyLoadImage
              src={`./images/apartments/blockP/${selectedApartment}.png`}
              alt=""
              effect="blur"
            />
          </div>

          <div className={cls.textWrapper}>
            <p>{apartments[selectedApartment].rooms}-комнатные</p>

            <div className={cls.detailItem}>
              <div>Объект:</div>
              <div>«Seven»</div>
            </div>

            <div className={cls.detailItem}>
              <div>Площадь квартиры:</div>
              <div>{apartments[selectedApartment].square} кв.м</div>
            </div>

            <div className={cls.detailItem}>
              <div>Адрес:</div>
              <div>Бишкек, мкрн Асанбай</div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls.imageContainer}>
        <div className={cls.imageBody}>
          <svg viewBox="0 0 1180 837.33331">
            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-6">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(1)}
                d="M 50.346978,419.23888V 302.65367 h 74.335112v -18.10313 h 42.32562v 91.28055 h 42.32562v 27.0272 H 147.88469 V 415.352H 98.419811 v 3.88688z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p3-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(2)}
                d="m 267.30795,350.52496v -46.72391 h 133.00061v 73.30491 h -20.39789v 43.60907 h 40.44377v 33.26416 h -19.83229 v 85.09857H 357.61228 V 417.65004h -39.30399 v 11.80923h -13.88261 v 2.79455h -8.47379 V 401.9645h -1.58486 v -27.34453h -27.05908 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(3)}
                d="m 404.21817,330.74854v -27.13872 h 89.28324v 74.01505 h -3.28321v 12.5304 h -2.61426v 44.31975 h -40.50773 v 26.89621h -1.2753 v 77.73858h -41.5802 v -81.20923h 19.96751 v -43.63222h -40.34546 v -33.39821 h 20.35541z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-5">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(4)}
                d="m 497.32601,342.42955v -55.49234 h 44.90688v 16.63208 h 37.92767v 14.38279 h -0.98802v 24.33525 h -5.43334v 35.58355 h 27.93476v 27.42905 h -13.10562v -2.65933 h -19.15619v 0.8564 h -75.14582v -24.22376 h 3.05968z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-4">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(5)}
                d="m 679.70674,363.65212v -60.03776 h 92.03986v 38.4646 h -5.0091v 36.65246 h 5.03573v 2.23102 h 20.20666v 33.30592 h -40.19022v 43.63222 h 19.9682V 538.92 h -41.46566v -77.54877 h -1.74845 V 417.51928H 689.7036 v 11.69691h -11.21884 v 2.61348h -10.77263 v -28.2702h 11.99461 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p3-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(6)}
                d="m 775.59783,332.45371v -28.83935 h 133.17188v 71.06935 h -27.13473v 57.29967 h -10.18604v -2.79455 h -13.70231 v -11.44864h -38.85326 v 121.15727h -43.3606 v -84.78947h -19.92244 v -33.21266h 40.16039 v -43.67612h -20.17289 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-6">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(7)}
                d="m 966.60493,389.08972v -13.38611 h 42.38937v -91.42573 h 42.2975v 19.4717 h 53.8913v -1.2234 h 20.1192v 116.80978 h -48.007v -3.72899 h -49.1712v -12.0649 h -61.51917z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(8)}
                d="m 1008.8668,504.91148v -40.0696 h -32.95533v -24.66182 h 30.75763v -1.95402 h 21.4482v -11.01777 h 49.0824v -3.92022 h 48.5082v 116.93727 h -20.4611v -1.14738 h -53.8631v 19.12302 h -42.5169z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-2">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(9)}
                d="m 913.21983,476.70502v -15.26654 h -1.30674v -23.07511 h 43.19207v 1.82337 h 14.42348v 28.46384 h 30.57346v 29.24913 h 4.9401v 55.16991 h -91.82237z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-3">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(10)}
                d="m 822.67233,453.78927v -32.15854 h 31.26614v 14.21477 h 27.72838v 2.42225 h 26.54913v 31.74422 h 0.57369v 82.7708 h -48.50873v -13.89606 h -37.60861z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-1">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(11)}
                d="m 638.51765,479.47786v -39.61652 h 28.98731v -4.01584 h 26.08438v -14.27407 h 31.23586v 48.54404 h 0.90147v 69.05243 h -87.20902z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-6">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(12)}
                d="m 543.20197,507.48131v -66.52833 h 19.13366v -1.12683 h 72.1625v 99.16146 h -91.29616z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-4">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(13)}
                d="m 450.18777,509.0548v -68.26918 h 18.51746v -2.51787 h 56.89098v 1.91231 h 13.73671v 98.89788 h -89.14515 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-7">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(14)}
                d="m 267.33982,528.08221v -89.96885 h 27.16972v -2.43396 h 27.49477v -14.24319 h 31.28093v 117.70548 h -38.01038 v 13.64108h -47.93504 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p1-8">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(15)}
                d="m 170.89606,552.62341v -84.04567 h 35.67529v -28.30086 h 14.39515v -2.041 h 42.99492v 23.13886 h -1.14738v 91.24867 z"
              />
            </a>

            <a rel="noreferrer" target="_blank" href="https://www.goldenhouse.kg/jk-seven/p2-5">
              <path
                fill="#3292ffcc"
                onMouseOver={() => onHoverOverApartment(16)}
                d="m 50.357287,488.59317v -65.14576 h 48.508728v 3.82461 H 147.8858v 10.93199 h 21.6079v 2.00792 h 30.53309v 24.49473 h -32.9848v 78.65307 h 0.81132v 14.91929 H 124.58285V 538.94254 H 70.65956 v 1.1553H 50.962849 V 498.692h -0.605562 z"
              />
            </a>
          </svg>

          <LazyLoadImage
            src="./images/floors/blockP.png"
            alt=""
            effect="blur"
            placeholderSrc='./images/placeholder/floorP.png'
          />
        </div>

        <div onClick={() => goPrevPage(22)} className={cls.navigationButton1}>
          <img src="./images/arrow.png" alt="" />
          <p>К выбору этажа</p>
        </div>
      </div>
    </div >
  );
};

export default ApartmentsP;
